import React, { useEffect, useState, useRef } from 'react';
import { Calendar, ChevronDown } from 'lucide-react';
export interface DateRangeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  options?: string[];
  'data-id'?: string;
}
export function DateRangeSelector({
  value,
  onChange,
  options = ['Next 7 days', 'Next 30 days', 'Next 3 months'],
  'data-id': dataId
}: DateRangeSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  const handleSelect = (option: string) => {
    onChange(option);
    setIsOpen(false);
  };
  return <div className="relative inline-block" ref={dropdownRef} data-id="element-1348">
      {/* Trigger Button */}
      <button type="button" onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center gap-2 h-10 px-3 bg-[#E0F2FE] text-[#0EA5E9] text-xs font-medium rounded-md hover:bg-[#BAE6FD] transition-colors duration-200 border border-transparent focus:outline-none focus:ring-2 focus:ring-[#0EA5E9]/20" data-id="element-1349">
        <span data-id="element-1350">{value}</span>
      </button>

      {/* Dropdown Menu */}
      {isOpen && <div className="absolute right-0 mt-2 w-48 bg-white border border-[#CBD5E1] rounded-md shadow-lg z-50 py-1" data-id="element-1351">
          {options.map(option => <button key={option} type="button" onClick={() => handleSelect(option)} className={`w-full px-4 py-2 text-left text-sm transition-colors ${option === value ? 'bg-[#E0F2FE] text-[#0369A1] font-medium' : 'text-[#0F172A] hover:bg-[#F8FAFC]'}`} data-id="element-1352">
              {option}
            </button>)}
        </div>}
    </div>;
}